var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFilialCardUm = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 13.676 0 8.514 2.767 4.983a13 13 0 0 1 2.216-2.216C8.514 0 13.676 0 24 0s15.486 0 19.017 2.767c.826.646 1.57 1.39 2.216 2.216C48 8.514 48 13.676 48 24s0 15.486-2.767 19.017c-.646.826-1.39 1.57-2.216 2.216C39.486 48 34.324 48 24 48S8.514 48 4.983 45.233a12.998 12.998 0 0 1-2.216-2.216C0 39.486 0 34.324 0 24Z",
    fill: "#F3F3F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.313 33h-.688v-1.719c0-.558-.473-1.031-1.031-1.031h-1.719v-7.563H29.5v7.563h-2.75v-7.563h-1.375v7.563h-2.75v-7.563H21.25v7.563H18.5v-7.563h-1.375v7.563h-1.719c-.601 0-1.031.473-1.031 1.031V33h-.688a.707.707 0 0 0-.687.688v.343c0 .215.129.344.344.344h21.312a.339.339 0 0 0 .344-.344v-.343c0-.344-.344-.688-.688-.688ZM15.75 31.625h16.5V33h-16.5v-1.375Zm18.906-12.031-10.011-4.34c-.172-.043-.473-.129-.645-.129-.215 0-.516.086-.688.129l-10.011 4.34c-.172.086-.301.3-.301.515v.344c0 .3.215.516.516.516h.859v.515c0 .301.215.516.516.516h18.218a.522.522 0 0 0 .516-.516v-.515h.86a.523.523 0 0 0 .515-.516v-.344c0-.215-.172-.43-.344-.515Zm-2.406 1.031h-16.5v-.559l8.035-3.523c.086 0 .13-.043.215-.043.043 0 .086.043.172.043l8.078 3.523v.559Z",
    fill: "#7C62E3"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFilialCardUm);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/filial-card-um.0cb64d820f924fd2c6bbb467b9144ade.svg";